'use strict';

var debounce = require('lodash/debounce');
var scrollAnimate = require('base:components/scrollAnimate');

$(document).ready(function () {
    $('.js-clickable-blog-article').on('click', function (e) {
        let $target = $(e.target);
        let $context = $(this).closest('.js-clickable-blog-article');
        let url = $('.js-blog-article-link', $context).attr('href');

        if (
            e.target.nodeName === 'A' || $target.closest('a', $context).length
        ) {
            return;
        }
        if (e.shiftKey || e.ctrlKey || e.metaKey) {
            // if cmd|ctrl|windows key is pressed at the same time, then open in a new tab
            window.open(url, '_blank');
        } else {
            window.location = url;
        }
    });

    /* START: SEARCH BLOG ARTICLES SECTION */
    let $gridContainer = $('.js-articles-grid-container');
    let searchWrapperSelector = '.js-content-search-wrapper';
    let paginationContainerSelector = '.js-blog-pagination-container';
    let debounceQSearch = debounce(function () {
        searchBlogArticles();
    }, 300);
    /**
     * makes ajax call for blog articles search
     * @param {string} action - 'renewFilters' if the filters have to be updated from server render
     * @param {string} forcedUrl - forced url for pagination
     */
    function searchBlogArticles(action, forcedUrl) {
        let renewFilters = action === 'renewFilters';
        let $searchWrapper = $(searchWrapperSelector, $gridContainer);
        let $searchResultContainer = $('.js-articles-search-result', $gridContainer);
        let q = $('input[name="q"]', $searchWrapper).val();
        let $refinements = $('input[name="refinementValues"]:checked', $searchWrapper);
        let fdid = $('select[name="tagFilter"]', $searchWrapper).val();
        let refinementValues = [];
        let ajaxUrl = $searchResultContainer.attr('data-action') + '?';
        let gridClasses = $searchResultContainer.attr('data-grid-classes');

        $refinements.each((index, checkbox) => {
            refinementValues.push($(checkbox).val());
        });
        ajaxUrl += fdid ? '&fdid=' + encodeURIComponent(fdid) : '';

        if (renewFilters === false) {
            ajaxUrl += refinementValues ? '&searchRefinements=' + encodeURIComponent(refinementValues.join(',')) : '';
            ajaxUrl += q ? '&q=' + encodeURIComponent(q) : '';
        }

        $.ajax({
            url: forcedUrl || ajaxUrl,
            method: 'GET',
            success: function (data) {
                if (renewFilters) {
                    $gridContainer.html(data);
                } else {
                    $searchResultContainer.html($(data).find('.js-articles-search-result').html());
                }
                $gridContainer.find('.js-blog-article-wrapper').each((index, el) => {
                    $(el).addClass(gridClasses);
                });


                let $paginationContainer = $(paginationContainerSelector);
                $paginationContainer.html($(data).find(paginationContainerSelector).html());

                if (forcedUrl && forcedUrl.length > 0 ) {
                    scrollAnimate($('.js-articles-grid-container'));
                }
            }
        });
    }
    $('body').on('change', searchWrapperSelector + ' input[name="refinementValues"]', function () {
        searchBlogArticles();
    });
    $('body').on('keyup click', searchWrapperSelector + ' input[name="q"]', function (e) {
        debounceQSearch(this, e);
    });
    $('body').on('change', searchWrapperSelector + ' select[name="tagFilter"]', function () {
        searchBlogArticles('renewFilters');
    });
    $('body').on('click', paginationContainerSelector + ' .js-ajax-pagination', function (e) {
        e.preventDefault();
        searchBlogArticles(null, $(this).attr('data-ajax-url'));
    });
    /* END: SEARCH BLOG ARTICLES SECTION */
});
